export const PRIVACY_POLICY = 'REGISTRATION_PRIVACY_POLICY';
export const TERMS_AND_CONDITIONS = 'REGISTRATION_TERMS_AND_CONDITIONS';
